import React from 'react'
import PropTypes from 'prop-types'
import { IconButton, makeStyles } from '@material-ui/core'
import Icon from '../../../../components/atoms/Icon'

const useStyles = makeStyles(() => ({
  linkCardButton: {
    opacity: 0,
    transition: 'opacity 0.2s ease',
    '.dai-link-card:hover &': {
      opacity: 1
    }
  }
}))

function LinkCardDots ({ onClick }) {
  const classes = useStyles()

  return (
    <IconButton
      className={classes.linkCardButton}
      onClick={onClick}
    >
      <Icon name='vertDots' customSize='24px' />
    </IconButton>
  )
}

LinkCardDots.propTypes = {
  onClick: PropTypes.func
}

export default LinkCardDots
